export default __webpack_public_path__ + "static/floor2-slide-5-1af44a297d715b299dfc6ff67e5ce720.jpg";